import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { CookieNames, IS_COOKIE_HTTPS_ONLY } from '../../../../../config/index';

export default () => {
  const [, setCookie] = useCookies([CookieNames.INSURANCE_BADGE]);

  useEffect(() => {
    setCookie(CookieNames.INSURANCE_BADGE, true, {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'setYear' does not exist on type 'Date'.
      expires: new Date(new Date().setYear(2099)),
      path: '/',
    });
  }, [setCookie]);
};
